import { Box, Grid, styled } from '@mui/material';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomDrawer from '../../common/CustomDrawer';
import Comments from '../../features/Comment/components/Comments';
import RnRDrawer from '../../features/RnR/RnRForm/components/RnRDrawer';
import ShabashDrawer from '../../features/Shabash/components/ShabashDrawer';
import Resume from '../../features/Resume/components/Resume';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../context/Ability';
import { Height } from '@mui/icons-material';
import GiftPreview from '../../features/Gift/components/common/GiftPreview';

const Main = styled('main', {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  flexGrow: 1,
  border: '0px solid black',
  transition: 'none',
  marginRight: open ? 10 : -350,
  overflowX: 'hidden',
  width: '100%',
  maxWidth: '100%',
  [theme.breakpoints.down('lg')]: {
    marginRight: 0,
    display: open ? 'none' : 'block',
  },
  position: 'relative',
}));

const drawerContent = {
  comment: {
    title: 'Feedbacks',
    component: <Comments />,
    ability: { action: 'create', module: 'Comment' },
  },
  rnr: {
    title: 'Nominate for RnR',
    component: <RnRDrawer />,
    ability: { action: 'create', module: 'RnR' },
  },
  rnrNomination: {
    title: 'Nominate for RnR',
    component: <RnRDrawer />,
    ability: { action: 'create', module: 'RnR' },
  },
  shabash: {
    title: 'Nominate for Shabash',
    component: <ShabashDrawer />,
    ability: { action: 'create', module: 'Shabash' },
  },
  shabashNomination: {
    title: 'Nominate for Shabash',
    component: <ShabashDrawer />,
    ability: { action: 'create', module: 'Shabash' },
  },
  resume: {
    title: 'Export Resume',
    component: <Resume />,
    ability: { action: 'create', module: 'Resume' },
  },
};

function Right () {
  const { pathname } = useLocation();
  const ability = useAbility(AbilityContext);
  const urlElements = pathname.split('/');
  const drawerKey = urlElements[4];
  const activePath = urlElements[2];
  const { empCode } = useParams();
  let open = ['comment', 'rnr', 'shabash', 'resume','rnrNomination','shabashNomination'].includes(drawerKey);
  const navigate = useNavigate();
  const { component, ability: abilityCheck, title } = drawerContent[drawerKey] || {};
  console.log('urlElements', urlElements)
  const handleNotFound = () => {
    if (open) {
      open = false;
      return navigate('/NotFound');
    }
  };
  const content = abilityCheck && ability.can(abilityCheck.action, abilityCheck.module) ? component : handleNotFound();
  const handleBackClick = () => {
    if (activePath === 'gift') {
      let newActivePath = urlElements[3];
      navigate(`gift/${newActivePath}`);
    }
    else if (activePath === 'rnr') {
      navigate(`/home/rnr/winners`);
    }
    else if (activePath === 'shabash') {
      navigate(`/home/shabash/winners`);
    }
     else {
      navigate(`${activePath}/${empCode}`);
    }
  };
  return (
    <Grid xs={12} item sx={{ border: 0, flex: 1, display: 'flex', p: 0, px: 0 }}>
      <Main open={open} sx={{ display: 'grid' }}>
        <Outlet />
      </Main>
      {/* width={350} */}
      <CustomDrawer open={open} content={content} title={title} handleBackClick={handleBackClick} />
    </Grid>
  );
}

export default Right;
